export const ROUTES = {
    STUDENT_DASHBOARD: { path: '/dashboard' },
};

export const DASHBOARD_TABS = ['currently-studying', 'curriculum'] as const;
